import { Injectable, Provider, Type } from '@angular/core';

export function provideGitDiffTree(service: Type<GitDiffTreeService>): Provider {
  return {
    provide: GitDiffTreeService,
    useClass: service,
  };
}

@Injectable()
export abstract class GitDiffTreeService {
  abstract getTypeDisplayName($schema: string): string | null;
  abstract getTypeLogo($schema: string): string | null;
}
